export default __webpack_public_path__ + "static/media/024-pull.edfe08f9.png";